module.exports = __webpack_public_path__ + "img/logo_4_small_bustracker.2bcdb494.png";